import { http } from "../../../shared/api/http"
import { CourseDropout } from "./adminAnalytics.api"

export type DateRangeFilters = {
  from_date?: string
  to_date?: string
}

/* ===================== MY COURSES ===================== */

export type MentorCourseSummary = {
  course_id: string
  title: string
  views: number
  purchases: number
  conversion_rate: number
  avg_rating: number
  reviews_count: number
  completion_rate: number
  revenue: number
}

export type MentorCoursesAnalytics = {
  total_views: number
  total_purchases: number
  total_revenue: number
  avg_completion_rate: number
  courses: MentorCourseSummary[]
}

export const getMentorCoursesAnalyticsApi = (filters: DateRangeFilters = {}) =>
  http.get<MentorCoursesAnalytics>("/api/me/analytics/courses", { params: filters })

/* ===================== MY COURSE DETAIL ===================== */

export type MentorCourseDetail = {
  course_id: string
  title: string
  views: number
  unique_visitors: number
  purchases: number
  avg_rating: number
  reviews_count: number
  completion_rate: number
  revenue: number
  views_by_day: { date: string; count: number }[]
  purchases_by_day: { date: string; count: number }[]
}

export const getMentorCourseDetailApi = (courseId: string) =>
  http.get<MentorCourseDetail>(`/api/me/analytics/courses/${courseId}`)

export const getMentorCourseDropoutApi = (courseId: string) =>
  http.get<CourseDropout>(`/api/me/analytics/courses/${courseId}/dropout`)

/* ===================== PROFILE VIEWS ===================== */

export type ProfileViewer = {
  user_id: string
  full_name: string
  avatar_url: string | null
  role: string
  viewed_at: string
}

export type MentorProfileViews = {
  total_views: number
  unique_visitors: number
  views_last_7_days: number
  viewers: ProfileViewer[]
}

export const getMentorProfileViewsApi = (params: { limit?: number; offset?: number } = {}) =>
  http.get<MentorProfileViews>("/api/me/analytics/profile/views", { params })
